import { ERRORS_LOCALIZATION_MAP } from '../constants';
import { Paragraph } from './shared/Paragraph';

interface Props {
  errorCode: string;
  localizationMap: Record<string, string>;
}

export const ErrorTemplate = ({ errorCode = '', localizationMap }: Props) => {
  const localizedKey =
    ERRORS_LOCALIZATION_MAP[
      errorCode as keyof typeof ERRORS_LOCALIZATION_MAP
    ] ?? ERRORS_LOCALIZATION_MAP.default;

  const text = localizationMap[localizedKey];

  if (text) {
    return text;
  }

  return null;
};
